import React, { useEffect, useState } from 'react';
import { MessageSquareText, AlignLeft } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

// Diálogo global «Ver motivo»: muestra el motivo de un rechazo o de una solicitud.
// Uso desde cualquier menú: commentAction(texto, { title, meta, testId }) → item de RowActionsMenu (sección Consultas).
let openFn = null;
export const openComment = (payload) => openFn?.(payload);

export const commentAction = (text, { title = 'Motivo', meta, testId } = {}) => ({
  label: 'Ver motivo', icon: MessageSquareText, view: true, hidden: !text, onClick: () => openComment({ title, text, meta }), testId,
});

// «Ver descripción»: muestra completo el texto libre del registro cuando la celda lo recorta
export const descriptionAction = (text, { title = 'Descripción', meta, testId } = {}) => ({
  label: 'Ver descripción', icon: AlignLeft, view: true, hidden: !(text && String(text).trim()), onClick: () => openComment({ title, text, meta }), testId,
});

export const CommentDialogHost = () => {
  const [c, setC] = useState(null);
  useEffect(() => { openFn = setC; return () => { openFn = null; }; }, []);
  return (
    <Dialog open={!!c} onOpenChange={(o) => !o && setC(null)}>
      <DialogContent className="max-w-md" data-testid="comment-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base"><MessageSquareText className="h-4 w-4 text-slate-500" />{c?.title}</DialogTitle>
          {c?.meta && <DialogDescription data-testid="comment-meta">{c.meta}</DialogDescription>}
        </DialogHeader>
        <p className="whitespace-pre-wrap rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 text-sm leading-relaxed text-slate-800" data-testid="comment-text">{c?.text}</p>
      </DialogContent>
    </Dialog>
  );
};
